// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jBn-","col":"styles_col__3szYB"};